var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconListRecipe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.069,
    height: 13.339,
    viewBox: "0 0 8.069 13.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27 -541.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.9,60.6a.623.623,0,0,1-.258.993,5.2,5.2,0,0,1-3.829-.241,6.53,6.53,0,0,1-3.235-3.307,6.966,6.966,0,0,1,2.567-8.682,5.4,5.4,0,0,1,4.244-.658.619.619,0,0,1,.211,1.052C110.859,52.26,110.921,57.116,113.9,60.6Z",
    transform: "translate(-78.984 493.151)",
    fill: "#f6a409"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListRecipe);
export default __webpack_public_path__ + "static/media/Icon-List-Recipe.83325f0c.svg";
export { ForwardRef as ReactComponent };